var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"padding":"40px"}},[_vm._v("页面不存在 :(")])
}
var staticRenderFns = []

export { render, staticRenderFns }